import React, { useState, useEffect } from 'react';
import { FaGoogle, FaFacebookF } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { getSocialConfig, loginWithGoogle, loginWithFacebook } from '../../utils/socialAuth';

const SocialButtons = ({ onSuccess, onError }) => {
  const { loginWithSocial } = useAuth();
  const [config, setConfig] = useState(null);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    getSocialConfig().then(setConfig);
  }, []);

  const handleGoogle = () => {
    if (!config?.google?.clientId) return;
    setBusy('google');
    loginWithGoogle(config.google.clientId);
  };

  const handleFacebook = async () => {
    if (!config?.facebook?.appId) return;
    setBusy('facebook');
    try {
      const accessToken = await loginWithFacebook(config.facebook.appId);
      if (!accessToken) { setBusy(null); return; }
      const result = await loginWithSocial('facebook', accessToken);
      if (result.success) onSuccess?.();
      else onError?.(result.error || 'Facebook login failed');
    } catch (e) {
      onError?.(e.message || 'Facebook login failed');
    }
    setBusy(null);
  };

  const googleEnabled = !!(config?.google?.enabled && config?.google?.clientId);
  const facebookEnabled = !!(config?.facebook?.enabled && config?.facebook?.appId);
  if (!googleEnabled && !facebookEnabled) return null;

  return (
    <div>
      <div className="flex items-center gap-3 my-4">
        <div className="flex-1 h-px bg-gray-200"></div>
        <span className="text-xs text-gray-500 uppercase tracking-wide">or continue with</span>
        <div className="flex-1 h-px bg-gray-200"></div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {googleEnabled && (
          <button type="button" onClick={handleGoogle} disabled={!!busy}
            className="flex items-center justify-center gap-2 py-2.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 transition-colors">
            <FaGoogle className="text-red-500" />
            {busy === 'google' ? 'Please wait...' : 'Google'}
          </button>
        )}
        {facebookEnabled && (
          <button type="button" onClick={handleFacebook} disabled={!!busy}
            className="flex items-center justify-center gap-2 py-2.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 transition-colors">
            <FaFacebookF className="text-blue-600" />
            {busy === 'facebook' ? 'Please wait...' : 'Facebook'}
          </button>
        )}
      </div>
    </div>
  );
};

export default SocialButtons;
